import type { Match } from '@airmail/engine';
import { useCompetition } from '@/store/TournamentProvider';
import { matchContext, scoreText, slotLabel, teamLookup } from '@/lib/teams';
import { cx } from '@/ui';
import { useT } from '@/i18n';

/** Kompakte Match-Karte (Warteschlange, Gruppen-Spielliste, Bracket) */
export function MatchRow({ match, onClick, right, muted, className, wrap }: { match: Match; onClick?: () => void; right?: React.ReactNode; muted?: boolean; className?: string; wrap?: boolean }) {
  const t = useT();
  const comp = useCompetition();
  const lookup = teamLookup(comp);
  const phase = comp.phases.find((p) => p.id === match.phaseId);
  const matches = phase?.matches ?? [];
  const winner = match.result?.winner;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className={cx('w-full text-left bg-panel2 border border-line px-3 py-2 flex items-center gap-3', onClick && 'cursor-pointer hover:border-muted', muted && 'opacity-50', className)}
    >
      <div className="min-w-0 flex-1">
        <div className="label flex gap-2">
          <span>{matchContext(comp, match)}</span>
          <span className="ml-auto">#{match.number}</span>
        </div>
        {/* In schmalen Spalten (Warteschlange) darf die Paarung umbrechen — sonst
            steht da „Sackflug vs Bag Br…" und man weiß nicht, wer spielt. */}
        <div className={cx('text-[14px] mt-0.5', wrap ? 'leading-snug' : 'truncate')}>
          <b className={cx(winner === 'A' && 'text-live')}>{slotLabel(match.a, lookup, matches, true)}</b>
          <span className="text-dim"> {t('vs')} </span>
          <b className={cx(winner === 'B' && 'text-live')}>{slotLabel(match.b, lookup, matches, true)}</b>
          {match.result && <span className="font-mono text-muted ml-2">{scoreText(match)}</span>}
        </div>
      </div>
      {right}
    </Tag>
  );
}
